// extracted by mini-css-extract-plugin
export var circle = "_97-1";
export var exitConfirmationModal = "_97-5";
export var iframe = "_97-0";
export var offline = "_97-3";
export var online = "_97-2";
export var workstationSelectError = "_97-4";